
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3.969c1.055 0 2.118.517 2.75 1.5l3.125 5.063 1.438-.844v5.313l-4.625-2.594 1.5-.875-3.125-5c-.53-.824-1.553-.806-2.094 0l-2.813 4.594-1.719-1.031L13.25 5.47A3.268 3.268 0 0116 3.97zm-5.594 8.125v5.313l-1.531-.938-2.625 4.25v.031l-.031.031C5.554 21.749 6.234 23 7.5 23H13v2H7.5c-2.712 0-4.409-3.084-2.938-5.313.012-.018-.012-.045 0-.063l.031.031 2.563-4.219-1.25-.75zm14.657 3.562l2.5 4v.031c1.36 2.312-.332 5.313-2.969 5.313H19v2l-4.906-3L19 21v2h5.594c1.163 0 1.89-1.193 1.25-2.281l-2.5-4z"}})])
          )
        }
      }
    